import { getEnvVar } from './env';

export const addSpaStaticsToHead = (): void => {
  const cdnBaseUrl = getEnvVar('VITE_VACV_COMMON_STATIC_URL');

  const fontsCssElem = document.createElement('link');
  fontsCssElem.setAttribute('rel', 'stylesheet');
  fontsCssElem.setAttribute('href', `${cdnBaseUrl}/fonts/fonts.css`);

  const fontsAwesomeCssElem = document.createElement('link');
  fontsAwesomeCssElem.setAttribute('rel', 'stylesheet');
  fontsAwesomeCssElem.setAttribute('href', `${cdnBaseUrl}/fonts/fontawesome/css/all.min.css`);
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(fontsCssElem);
  head.appendChild(fontsAwesomeCssElem);
};
